import React from 'react';
import PropTypes from 'prop-types';
import DisplayTemplate from './DisplayTemplate';
import EditTemplate from './EditTemplate';

const propTypes = {
    children: PropTypes.arrayOf(
        PropTypes.oneOfType([
            PropTypes.objectOf(DisplayTemplate),
            PropTypes.objectOf(EditTemplate)
        ])
    ).isRequired,
    mode: PropTypes.string
};

const defaultProps = {
    mode: "display"
};

export class EditableWrapper extends React.Component {
    render() {
        let childComponents = null;
        switch (this.props.mode) {
            case "display":
                childComponents = this.props.children[0];
                break;
            case "edit":
                childComponents = this.props.children[1];
                break;
            default:
                childComponents = null;
        }

        return (
            <div>{childComponents}</div>
        );
    }
}

EditableWrapper.propTypes = propTypes;
EditableWrapper.defaultProps = defaultProps;

export default EditableWrapper;
